import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type Tone = 'green' | 'yellow' | 'red' | 'blue' | 'neutral';

export function Badge({ tone = 'neutral', children, title }: { tone?: Tone; children: ReactNode; title?: string }) {
  return <span className={`badge ${tone === 'neutral' ? '' : tone}`} title={title}>{children}</span>;
}

export function EmptyState({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty">
      <b>{title}</b>
      {children}
      {action && <div>{action}</div>}
    </div>
  );
}

export function PageHeader({ title, description, actions }: { title: string; description?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      <div className="grow" />
      {actions}
    </div>
  );
}

export function Loading({ label = 'Chargement…' }: { label?: string }) {
  return <div className="empty" role="status">{label}</div>;
}

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  return <div className="error-box" role="alert">{error instanceof Error ? error.message : String(error)}</div>;
}

export function IconButton({ icon, label, onClick, tone, disabled }: { icon: IconName; label: string; onClick: () => void; tone?: 'danger'; disabled?: boolean }) {
  return (
    <button type="button" className={`btn ghost small icon ${tone ?? ''}`} aria-label={label} title={label} onClick={onClick} disabled={disabled}>
      <Icon name={icon} size={15} />
    </button>
  );
}

export function Field({ label, hint, children, htmlFor }: { label: string; hint?: ReactNode; children: ReactNode; htmlFor?: string }) {
  return (
    <div className="field">
      <label htmlFor={htmlFor}>{label}</label>
      {children}
      {hint && <small>{hint}</small>}
    </div>
  );
}
